import { NavLink } from "react-router-dom";

import { Controls, ControlsButton } from "@/components/Controls";
import { PageHeading } from "@/components/Layout/Parts";
import { TableHeader } from "@/components/Table";
import Text from "@/components/Text";
import PendingBonusesTable from "./components/PendingBonusesTable";
import ApprovedBonusesTable from "./components/ApprovedBonusesTable";

const GamificationBonuses = () => {
  return (
    <>
      <Text $type="caption" $color="gray">
        ALL TEAMS
      </Text>
      <PageHeading>Bonuses</PageHeading>
      <TableHeader>
        <Controls>
          <NavLink
            to="/general/gamification/bonuses/thumb"
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Thumb
              </ControlsButton>
            )}
          />
        </Controls>
      </TableHeader>
      <PendingBonusesTable />
      <ApprovedBonusesTable />
    </>
  );
};

export default GamificationBonuses;
